import { render, staticRenderFns } from "./StatusForm.vue?vue&type=template&id=8b377010&scoped=true&"
import script from "./StatusForm.vue?vue&type=script&lang=js&"
export * from "./StatusForm.vue?vue&type=script&lang=js&"
import style0 from "./StatusForm.vue?vue&type=style&index=0&id=8b377010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b377010",
  null
  
)

export default component.exports